import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
} from '@chakra-ui/react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { EMPLOYER_BUSINESS_TYPES } from '@duke-hq/shared-constants/employer';
import type { EmployerBusinessFieldValues } from '@duke-hq/svc-api/admin/trpc/routers/workPlacements/employers/schemas';
import { testIds } from '../testIds';

export function EmployerBusinessFields(): React.ReactElement {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<EmployerBusinessFieldValues>();
  const businessType = useWatch({ control, name: 'businessType' });

  return (
    <>
      <FormControl isRequired isInvalid={errors.name != null}>
        <FormLabel>
          <Trans>Business name</Trans>
        </FormLabel>
        <Input
          {...register('name')}
          placeholder={t`Business name`}
          data-testid={testIds.employerNameInput}
        />
        <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
      </FormControl>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <FormControl isInvalid={errors.abn != null}>
          <FormLabel>
            <Trans>ABN</Trans>
          </FormLabel>
          <Input
            {...register('abn')}
            placeholder={t`Enter ABN`}
            data-testid={testIds.employerAbnInput}
          />
          <FormErrorMessage>{errors.abn?.message}</FormErrorMessage>
        </FormControl>
        <FormControl>
          <FormLabel>
            <Trans>Business type</Trans>
          </FormLabel>
          <Select
            {...register('businessType')}
            placeholder={t`Select business type`}
            data-testid={testIds.employerBusinessTypeSelect}
          >
            {EMPLOYER_BUSINESS_TYPES.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
            <option value="Other">{t`Other`}</option>
          </Select>
        </FormControl>
      </SimpleGrid>

      {businessType === 'Other' ? (
        <FormControl isRequired isInvalid={errors.businessTypeOther != null}>
          <FormLabel>
            <Trans>Other business type</Trans>
          </FormLabel>
          <Input
            {...register('businessTypeOther')}
            placeholder={t`Enter business type`}
            data-testid={testIds.employerBusinessTypeOtherInput}
          />
          <FormErrorMessage>{errors.businessTypeOther?.message}</FormErrorMessage>
        </FormControl>
      ) : null}
    </>
  );
}
